import React from 'react';
export function CommentIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("g", {
    clipPath: "url(#svg__924c7__clip0)"
  }, React.createElement("path", {
    d: "M19 7H5v2h14V7zM5 11h7v2H5v-2z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6 18.75A2 2 0 007.04 18H3a3 3 0 01-3-3V5a3 3 0 013-3h18a3 3 0 013 3v10a3 3 0 01-3 3h-4.038a2 2 0 00-1.562.75L12 23l-3.4-4.25zM21 4H3a1 1 0 00-1 1v10a1 1 0 001 1h4.039a4 4 0 013.123 1.501L12 19.798l1.838-2.297A4 4 0 0116.96 16H21a1 1 0 001-1V5a1 1 0 00-1-1z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "svg__924c7__clip0"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}